import React, { useState, useEffect } from 'react';

import { Grid, Box } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Description } from '@mui/icons-material';

import Typography from '@mui/material/Typography';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import { Select, MenuItem, InputLabel, FormControl, CircularProgress, Backdrop } from '@mui/material';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';


import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate hook

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { url, urlLive, fileUploadUrl } from "../../constant";

import image040 from '../../assets/custom-icon/image040.png';
import image041 from '../../assets/custom-icon/image041.jpg';
import image042 from '../../assets/custom-icon/image042.jpg';

import Pagination from '@mui/material/Pagination';

import Link from '@mui/material/Link';
import LinkIcon from '@mui/icons-material/Link';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import button from 'assets/theme-dark/components/button';
import MDBadge from 'components/MDBadge';
import { Chip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn'; // Import location icon (or any other icon)
import FavoriteIcon from '@mui/icons-material/Favorite'; // Heart icon
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FilterListIcon from '@mui/icons-material/FilterList';
import TuneIcon from '@mui/icons-material/Tune';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';


function RequestList4() {

    const [requests, setRequests] = useState([]);  // Stores the requests data
    const [searchQuery, setSearchQuery] = useState('');  // State for the search query
    const [filteredRequests, setFilteredRequests] = useState([]); // Stores the filtered requests
    const [page, setPage] = useState(1); // State for current page
    const [itemsPerPage, setItemsPerPage] = useState(8); // Number of items to show per page
    const [requestTypes, setRequestTypes] = useState([]);
    const [requestCategories, setRequestCategories] = useState([]);
    const [userCompanyName, setUserCompanyName] = useState('');
    const [userCompanyId, setUserCompanyId] = useState('');
    const [selectedRequestType, setSelectedRequestType] = useState('');  // State for the selected typology
    const [selectedRequestCategory, setSelectedRequestCategory] = useState('');  // State for the selected typology
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedChip, setSelectedChip] = useState(null);
    const [selectedChips, setSelectedChips] = useState([]);

    const [visibleCount, setVisibleCount] = useState(itemsPerPage); // initially show itemsPerPage
    const visibleRequests = filteredRequests.slice(0, visibleCount);

    // Add loading states
    const [loading, setLoading] = useState(false);  // For fetching categories
    const [formLoading, setFormLoading] = useState(false);  // For form submission

    // States for each switch
    const [allAds, setAllAds] = useState(true);  // default checked for "All ads"
    const [myAds, setMyAds] = useState(false);  // default unchecked for "My ads"

    // State to track the active button
    const [activeButton, setActiveButton] = useState(null);

    const navigate = useNavigate(); // Initialize the navigate function

    const locations = useLocation(); // Get the current URL location
    const queryParams = new URLSearchParams(locations.search); // Extract query parameters

    const [catReq, setcatReq] = useState(''); // Initialize state with null

    // Get user data from localStorage (user ID)
    const userData = localStorage.getItem('user');
    const user = userData ? JSON.parse(userData).user : null;
    const userId = user ? user.IdUser : null;
    const IdCompany = user ? user.IdCompany : null;
    const IsCompanyAdmin = user ? user.IsAdminCompany : null;
    const IsAdminPlatform = user ? user.IsAdminPlatform : null;

    // console.log('hhh', IsAdminPlatform);

    const width = window.innerWidth;
    const height = window.innerHeight;

    // console.log(`Width: ${width}, Height: ${height}`);

    // Fetch requests when the component mounts
    useEffect(() => {
        fetchRequests();
    }, []);  // Empty dependency array to run only once when the component mounts

    // Fetch all request types when the component mounts
    useEffect(() => {
        // fetchRequestTypes();
        fetchRequestCategories();

    }, [catReq]);
    // console.log(catReq);

    // // Fetch RequestTypes  filter by
    React.useEffect(() => {
        fetchRequestTypes();
    }, []);

    useEffect(() => {
        const rawQuery = queryParams.get("search_query");

        if (rawQuery) {
            const query = decodeURIComponent(rawQuery);
            setSearchQuery(query);
            fetchRequests(query, selectedRequestCategory, myAds);

            console.log('Query:', query);
        }
    }, []); // ✅ NOT searchQuery

    useEffect(() => {
        const company_id = queryParams.get("company_id");
        const request_type = queryParams.get("request_type");
        
        // If company_id exists, prioritize "My Ads" filtering
        if (company_id) {
            

            if(queryParams.get("request_type") && queryParams.get("cat_req")){
                
                const catId = queryParams.get("cat_req");
                const request_type_id = queryParams.get("request_type");

                console.log('category,company,requestType ids exits');
                setMyAds(true);
                setAllAds(false);
                fetchRequests(searchQuery, catId, request_type_id, company_id, false);

            }else if(queryParams.get("cat_req")){

                const catId = queryParams.get("cat_req");
                console.log('category and company id exits');
                setMyAds(true);
                setAllAds(false);
                fetchRequests(searchQuery, catId, '', company_id, false);

            }else if(queryParams.get("request_type")){

                const request_type_id = queryParams.get("request_type");
                console.log('request_type and company id exits');
                setMyAds(true);
                setAllAds(false);
                fetchRequests(searchQuery, '', request_type_id, company_id, false);

            } else{
                console.log('category,request_type ids not exits');
                fetchRequests(searchQuery, '', '', company_id, true);
                setMyAds(true);
                setAllAds(false);
            }

            
        } 
        // Otherwise, if request_type exists, filter by that
        else if (request_type) {
            
            if(queryParams.get("cat_req") && queryParams.get("request_type")){

                let request_type = queryParams.get("request_type");
                let request_name = queryParams.get("request_name");
                fetchRequests('', catReq, request_type);

            }else{

                fetchRequests('', '', request_type);

            }

            console.log('selected chip');
        }
    
    }, [userCompanyId, selectedChip]);

    useEffect(() => {
        setVisibleCount(itemsPerPage); // reset on filter change
    }, [filteredRequests]);

    // Fetch request types
    // const fetchRequestTypes = async () => {
    //     try {
    //         setIsLoading(true);
    //         const response = await fetch(`${url}auth/get-request-types`);
    //         const data = await response.json();
    //         setRequestTypes(data.data || []);

    //         const typeReq = queryParams.get("type_req");
    //         const typeName = queryParams.get("type_nam");
    //         if (catReq) {
    //             setActiveButton(typeName);
    //             fetchRequests(searchQuery, catReq, myAds);
    //         }

    //     } catch (error) {
    //         console.error("Error fetching request types:", error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const fetchRequestCategories = async () => {
        var formData = new FormData();
        formData.append('userId', userId);
        try {
            setIsLoading(true);
            const response = await fetch(`${url}auth/request-categories?IdCompany=${IdCompany}`);
            const data = await response.json();
            setRequestCategories(data.categories || []);
            setUserCompanyName(data.companyName || '');
            // console.log('data',data);
            setUserCompanyId(data.IdCompany || '');

            const catReq = queryParams.get("cat_req");
            const catName = queryParams.get("cat_nam");
            if (catReq) {

                fetchRequests(searchQuery, catReq, myAds);
                setActiveButton(catName);
                // console.log(activeButton);
            }

        } catch (error) {
            console.error("Error fetching request types:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Fetch requests based on search and request type
    const fetchRequests = (searchQuery = '', categoryType = '',requestType = '', companyId = '', isMyAds = false) => {

        setLoading(true);  // Show loader while fetching data
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        let urlWithQuery = `${url}auth/get-requests`; // Default to all requests

        // If filtering by "My Ads", use the user ID
        if (isMyAds && userId) {
            // urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}`; // Filter by user ID
        } else if (categoryType && companyId && requestType) {
            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(categoryType)}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
        }else if (requestType && companyId) {
            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
        } else if (categoryType && companyId) {

            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(categoryType)}`; // Filter by user ID

        } else if (searchQuery && requestType && categoryType) {
            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(categoryType)}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
        }else if (requestType && categoryType) {
            urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(categoryType)}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
        } else if (searchQuery && requestType) {
            urlWithQuery = `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&RequestType=${encodeURIComponent(requestType)}`;
            // urlWithQuery = `${url}auth/search-requests?RequestType=${encodeURIComponent(requestType)}`;
        } else if (requestType) {
            
            if(queryParams.get("cat_req") && queryParams.get("request_type")){
                urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(queryParams.get("cat_req"))}&RequestType=${encodeURIComponent(requestType)}`; // Filter by user ID
            }else{
                urlWithQuery = `${url}auth/search-requests?RequestType=${encodeURIComponent(requestType)}`;
            }


        } else if (searchQuery) {
            urlWithQuery = `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}`;
        } else if (categoryType) {

            if (queryParams.get("company_id")) {

                if(queryParams.get("cat_req") && queryParams.get("request_type") && queryParams.get("company_id")){
                    return;
                }else{
                    urlWithQuery = `${url}auth/search-requests?UserId=${userId}&Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&companyId=${encodeURIComponent(companyId)}&CategoryId=${encodeURIComponent(categoryType)}`; // Filter by user ID
                }

            } else {

                 
                if (queryParams.get("cat_req") && queryParams.get("request_type")) {
                    return;
                } else {
                    urlWithQuery = `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&CategoryId=${encodeURIComponent(categoryType)}`;
                }


            }

            
        }

        fetch(urlWithQuery, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.message === "Requests retrieved successfully.") {
                    setRequests(result.data);
                    setFilteredRequests(result.data);

                    const raw = sessionStorage.getItem('visibleCount');

                    if (raw !== null) {
                        const count = parseInt(raw);
                        if (!isNaN(count)) {
                            console.log("Item exists and is a valid number:", count);
                            setItemsPerPage(count);
                        } else {
                            console.log("Item exists but is not a valid number");
                        }
                    } else {
                        console.log("Item does NOT exist in sessionStorage");
                    }

                    sessionStorage.removeItem('visibleCount');

                }

                if (result.message === "Search results retrieved successfully.") {
                    setRequests(result.search_data);
                    setFilteredRequests(result.search_data);
                    // setActiveButton(queryParams.get("cat_nam"));
                }
            })
            .catch((error) => console.error("Error fetching requests:", error))
            .finally(() => {
                setLoading(false);  // Hide loader after fetching
            });

    };

    // Handle search input change
    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (query.trim() == '') {
            navigate(`/dashboard`);
            // // window.location.reload();
            fetchRequests();
        } else {
            navigate(`/dashboard?search_query=${query}`);

            // fetchRequests(query, selectedRequestType, myAds); // Pass searchQuery and myAds state
            fetchRequests(query, selectedRequestCategory, myAds); // Pass searchQuery and myAds state

        }


    };


    // Handle request type change
    // const handleRequestTypeChange = (event) => {
    //     const selectedType = event.target.value;
    //     alert(selectedType)
    //     // setSelectedRequestType(selectedType);
    //     setSelectedRequestCategory(selectedType);
    //     fetchRequests(searchQuery, selectedType, myAds); // Pass selectedRequestType and myAds state
    // };

    // Handle Category type change
    const handleCategoryTypeChange = (event) => {
        const selectedType = event.target.value;
        // setSelectedRequestType(selectedType);
        setSelectedRequestCategory(selectedType);
        fetchRequests(searchQuery, selectedType, myAds); // Pass selectedRequestType and myAds state
    };

    // Handle the "All Ads" switch change
    const handleAllAdsChange = (event) => {
        if (event.target.checked) {
            setAllAds(true);
            setMyAds(false);
            // fetchRequests(searchQuery, selectedRequestType, false); // Show all ads
            fetchRequests(searchQuery, selectedRequestCategory, false); // Show all ads
        } else {
            setAllAds(false);
        }
    };

    // Handle the "My Ads" switch change
    const handleMyAdsChange = (event, userCompanyId) => {
        if (event.target.checked) {
            setMyAds(true);
            setAllAds(false);
            // setActiveButton(null);
            // fetchRequests(searchQuery, selectedRequestType, true); // Filter by user ID for "My Ads"
            // fetchRequests(searchQuery, selectedRequestCategory, true); // Filter by user ID for "My Ads"

            // Update the URL with the selected filter (using query params)

            let id = queryParams.get("cat_req");
            let buttonName = queryParams.get("cat_nam");
            // If the clicked button is not active, set it as active
            setActiveButton(buttonName);

            if (queryParams.get("request_type") && queryParams.get("cat_req")) {

                let request_type_id = queryParams.get("request_type");
                let request_name = queryParams.get("request_name");

                let id = queryParams.get("cat_req");
                let buttonName = queryParams.get("cat_nam");

                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&request_type=${request_type_id}&request_name=${request_name}&company_id=${userCompanyId}`);
                fetchRequests(searchQuery, id, request_type_id, userCompanyId, false); // Filter by user ID and company for "My Ads"

            } else if (queryParams.get("request_type")) {
                
                let request_type_id = queryParams.get("request_type");
                let request_name = queryParams.get("request_name");
                navigate(`/dashboard?request_type=${request_type_id}&request_name=${request_name}&company_id=${userCompanyId}`);
                fetchRequests(searchQuery, '', request_type_id, userCompanyId, false); // Filter by user ID and company for "My Ads"

            } else if (queryParams.get("cat_req")) {

                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&company_id=${userCompanyId}`);
                fetchRequests(searchQuery, id, '', userCompanyId, false); // Filter by user ID and company for "My Ads"


            } else {
                navigate(`/dashboard?company_id=${userCompanyId}`);
                fetchRequests(searchQuery, '', '', userCompanyId, true); // Filter by user ID and company for "My Ads"
            }

            
            // console.log('fdjdk',userCompanyId);
        } else {
            setMyAds(false);
            setAllAds(true);
            setActiveButton('');
            // fetchRequests(searchQuery, selectedRequestType, false); // Show all ads
            fetchRequests(searchQuery, selectedRequestCategory, false); // Show all ads
            navigate(`/dashboard`);
            window.location.reload();
        }
    };

    // Navigate with the activeTab parameter (optional for page navigation)
    const handleButtonClick = () => {
        const activeTab = 1; // Example dynamic parameter
        // navigate(`/dashboard/request-list?activeTab=${activeTab}`);
        navigate(`/dashboard/Elenco-Richieste?activeTab=${activeTab}`);

        // window.location.href=`/dashboard/Elenco-Richieste?activeTab=${activeTab}`;
    };

    // const handleRequestTypeButtonClick = (buttonName,id) => {
    //     setActiveButton(buttonName);  // Set the active button
    //     // You can add functionality to filter requests based on the button here.

    //     // Example: Filter requests based on the button clicked
    //     // if (buttonName === 'propane') {
    //     //     // Call a function to filter requests for propane type

    //     //     fetchRequests(searchQuery, 48, myAds);
    //     // } else if (buttonName === 'cerca') {
    //     //     // Call a function to filter requests for cerca type

    //     //     fetchRequests(searchQuery, 3, myAds);
    //     // } else if (buttonName === 't&m') {
    //     //     // Call a function to filter requests for cerca type

    //     //     fetchRequests(searchQuery, 49, myAds);
    //     // }

    //     navigate(`/dashboard?type_req=${id}&type_nam=${buttonName}`);
    //     setcatReq(queryParams.get("type_req"));
    //     // fetchRequests(searchQuery, id, myAds);
    //     console.log(`${buttonName} button clicked`);
    // };

    const handleRequestTypeButtonClick = (buttonName, id) => {

        // Use match() for case-insensitive matching (if you want to ignore case)
        const pattern = new RegExp(buttonName, 'i'); // Creates a regex pattern to match buttonName case-insensitively

        // Toggle the active button state
        if (pattern.test(activeButton)) { // activeButton === buttonName
            // If the clicked button is already active, reset the active state (remove the filter)
            setActiveButton(null); // Reset active button (or null if you want to reset everything)
            // Optionally, reset the request filter if no button is active
            navigate('/dashboard'); // Navigate to the default state, without any filter
            window.location.reload();
        } else {
            // If the clicked button is not active, set it as active
            setActiveButton(buttonName);
            setUserCompanyId('');
            

            if(queryParams.get("request_type") && queryParams.get("company_id")){
                
                let company_id = queryParams.get("company_id");
                let request_type = queryParams.get("request_type");
                let request_name = queryParams.get("request_name");

                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&request_type=${request_type}&request_name=${request_name}&company_id=${company_id}`);
                fetchRequests(searchQuery, id, request_type, company_id, false);


            }else if(queryParams.get("company_id")){

                console.log('exits',queryParams.get("company_id"));
                let company_id = queryParams.get("company_id");
                
                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&company_id=${company_id}`);
                // setcatReq(queryParams.get("cat_req"));
                fetchRequests(searchQuery, id, '', company_id, false);

            } else if(queryParams.get("request_type")){

                let request_type = queryParams.get("request_type");
                let request_name = queryParams.get("request_name");
                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&request_type=${request_type}&request_name=${request_name}`);
                setcatReq(id);
                

            } else {

                setMyAds(false);
                setAllAds(true);
                // console.log(buttonName);
                // Update the URL with the selected filter (using query params)
                setSearchQuery('');
                navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}`);
                setcatReq(queryParams.get("cat_req"));

            }

            
        }

        // Fetch data based on the selected filter
        // You can call your fetchRequests function to reload data based on the button clicked
        // fetchRequests(searchQuery, id, myAds);

        console.log(`${buttonName} ${activeButton} button clicked`);
    };


    // Inside your component function
    const handleDetailsClick = (requestId) => {

        let searchTerm = btoa(window.location.search);
        // Navigate to the details page with the request ID as a URL parameter
        navigate(`/Richieste-Dettagli?requestId=${btoa(requestId)}&backUrlTerm=${searchTerm}`);

        sessionStorage.setItem('visibleCount', visibleCount);

        // window.location.href=`/dashboard/Richieste-Dettagli?requestId=${btoa(requestId)}`;

        // console.log("specific-req:",requestId);

    };

    const formatDate = (dateString) => { const date = new Date(dateString); const day = String(date.getDate()).padStart(2, '0'); const month = String(date.getMonth() + 1).padStart(2, '0'); const year = date.getFullYear(); return `${day}-${month}-${year}`; };

    const fetchRequestTypes = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${url}auth/get-request-types`);
            const data = await response.json();
            setRequestTypes(data.data || []);
        } catch (error) {
            console.error("Error fetching request types:", error);
        } finally {
            setIsLoading(false);
        }

    };

    // // Update Function to fetch requests from API 
    // const fetchRequests = (searchQuery = '', requestType = '') => {
    //     const requestOptions = {
    //         method: "GET",
    //         redirect: "follow"
    //     };

    //     let urlWithQuery = `${url}auth/get-requests`; // Default to all requests

    //     // If there's a searchQuery, append it to the URL
    //     if (searchQuery && requestType) {
    //         urlWithQuery = `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}&RequestType=${encodeURIComponent(requestType)}`;
    //     } else if (searchQuery) {
    //         urlWithQuery = `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}`;
    //     } else if (requestType) {
    //         urlWithQuery = `${url}auth/search-requests?Type=${encodeURIComponent(requestType)}`;
    //     }

    //     fetch(urlWithQuery, requestOptions)
    //         .then((response) => response.json())
    //         .then((result) => {
    //             if (result.message === "Requests retrieved successfully.") {
    //                 setRequests(result.data);  // Set the fetched requests data
    //                 setFilteredRequests(result.data); // Initially, display all requests
    //             }

    //             if (result.message === "Search results retrieved successfully.") {
    //                 setRequests(result.search_data);  // Set the fetched requests data
    //                 setFilteredRequests(result.search_data); // Initially, display all requests
    //             }
    //         })
    //         .catch((error) => console.error("Error fetching requests:", error));
    // };

    // // Update Handle the search input change
    // const handleSearchChange = (event) => {
    //     const query = event.target.value;
    //     setSearchQuery(query);

    //     // Fetch requests based on search query and selected request type
    //     fetchRequests(query, selectedRequestType);  // Pass both searchQuery and selectedRequestType
    // };

    // // Update Handle change in request type selection
    // const handleRequestTypeChange = (event) => {
    //     const selectedType = event.target.value;
    //     setSelectedRequestType(selectedType);

    //     // Fetch requests based on search query and selected request type
    //     fetchRequests(searchQuery, selectedType);  // Pass searchQuery and selectedRequestType
    // };


    // const handleButtonClick = () => {
    //     const activeTab = 1; // Example dynamic parameter
    //     // navigate(`/dashboard/request/${activeTab}`); // Navigate with the parameter
    //     navigate(`/dashboard/request?activeTab=${activeTab}`); // Navigate with the parameter
    // };

    // // Handle the "All ads" switch change
    // const handleAllAdsChange = (event) => {
    //     if (event.target.checked) {
    //         setAllAds(true);  // Turn on "All ads"
    //         setMyAds(false);  // Turn off "My ads"
    //     } else {
    //         setAllAds(false); // Turn off "All ads"
    //     }
    // };

    // // Handle the "My ads" switch change
    // const handleMyAdsChange = (event) => {
    //     if (event.target.checked) {
    //         setMyAds(true);   // Turn on "My ads"
    //         setAllAds(false); // Turn off "All ads"
    //     } else {
    //         setMyAds(false);  // Turn off "My ads"
    //     }
    // };




    // Function to fetch requests from API
    // const fetchRequests = (searchQuery = '') => {
    //     const requestOptions = {
    //         method: "GET",
    //         redirect: "follow"
    //     };

    //     // If searchQuery exists, include it in the query string
    //     const urlWithQuery = searchQuery
    //         ? `${url}auth/search-requests?Title=${encodeURIComponent(searchQuery)}&Description=${encodeURIComponent(searchQuery)}`
    //         : `${url}auth/get-requests`;

    //     fetch(urlWithQuery, requestOptions)
    //         .then((response) => response.json())
    //         .then((result) => {
    //             if (result.message === "Requests retrieved successfully.") {
    //                 setRequests(result.data);  // Set the fetched requests data
    //                 setFilteredRequests(result.data); // Initially, display all requests
    //             }

    //             if (result.message === "Search results retrieved successfully.") {
    //                 setRequests(result.search_data);  // Set the fetched requests data
    //                 setFilteredRequests(result.search_data); // Initially, display all requests
    //             }

    //         })
    //         .catch((error) => console.error("Error fetching requests:", error));
    // };

    // Handle the search input change
    // const handleSearchChange = (event) => {
    //     const query = event.target.value;
    //     setSearchQuery(query);

    //     // Fetch the filtered data based on the search query
    //     fetchRequests(query);
    // };



    // Handle change in typology selection
    // const handleRequestTypeChange = (event) => {
    //     setSelectedRequestType(event.target.value);
    // };


    // Handle page change
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    // Get current requests for the paginations
    // const currentRequests = filteredRequests.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    // Get current requests for the load more paginations
    const currentRequests = filteredRequests.slice(0, visibleCount);
    
    // // Fetch requests when the component mounts
    // useEffect(() => {
    //     const requestOptions = {
    //         method: "GET",
    //         redirect: "follow"
    //     };

    //     fetch(`${url}auth/get-requests`, requestOptions)
    //         .then((response) => response.json())
    //         .then((result) => {
    //             if (result.message === "Requests retrieved successfully.") {
    //                 setRequests(result.data);  // Set the fetched requests data
    //                 setFilteredRequests(result.data); // Initially, display all requests
    //             }
    //         })
    //         .catch((error) => console.error("Error fetching requests:", error));
    // }, []);  // Empty dependency array to run only once when the component mounts



    // // FullRemoteLabel Component with concise text and improved styling
    // const FullRemoteLabel = ({ fullRemote }) => {
    //     let label;
    //     let labelStyle;

    //     switch (fullRemote) {
    //         case 1:
    //             label = "Remote";  // Short, professional text
    //             labelStyle = { color: '#28a745', fontWeight: 'bold' };  // Green for remote
    //             break;
    //         case 0:
    //             label = "On-site";  // Short, professional text
    //             labelStyle = { color: '#dc3545', fontWeight: 'bold' };  // Red for on-site
    //             break;
    //         default:
    //             label = "Unknown";  // Fallback text
    //             labelStyle = { color: '#6c757d', fontWeight: 'normal' };  // Gray for unknown status
    //     }

    //     return <span style={labelStyle}>{label}</span>;
    // };

    // // Handle the search input change
    // const handleSearchChange = (event) => {
    //     const query = event.target.value;
    //     setSearchQuery(query);

    //     if (query === "") {
    //         // If the search query is empty, reset to show all requests
    //         setFilteredRequests(requests);
    //     } else {
    //         // Filter requests based on the query
    //         const filtered = requests.filter((request) => {
    //             const titleMatches = request.Title && request.Title.toLowerCase().includes(query);
    //             const descriptionMatches = request.Description && request.Description.toLowerCase().includes(query);

    //             return titleMatches || descriptionMatches;
    //         });

    //         setFilteredRequests(filtered);  // Update the filtered requests
    //     }

    // };

    const ZoomAvatar = styled(Avatar)(({ theme }) => ({
        width: 45,
        height: 45,
        '&:hover': {
            transform: 'scale(1.2)',  // This will zoom the image on hover
            transition: 'transform 0.3s ease',  // Smooth transition effect
        },
    }));

    // Function to handle truncation of description
    const truncatedDescription = (text, limit) => {
        if (text.length > limit) {
            return `${text.substring(0, limit)}...`;
        }
        return text;
    };

    // fuction multi select chip 

        // const handleChipClick = (chip) => {
        //     // Add to selected if not already there
        //     if (!selectedChips.some(c => c.RequestType === chip.RequestType)) {
        //       setSelectedChips([...selectedChips, chip]);
        //     }
        //         console.log('Chip clicked:', selectedChip);
        //   };
        
        //   const handleChipDelete = (chipToDelete) => {
        //     setSelectedChips(selectedChips.filter(chip => chip.RequestType !== chipToDelete.RequestType));
            
        //   };

    // end-fuction multi select chip 


    // fuction single select chip 
    const handleChipClick = (chip) => {
        // If same chip is clicked again, don't toggle, just stay selected
        if (selectedChip?.RequestType === chip.RequestType) return;
        setSelectedChip(chip);
        // fetchRequests('','',chip.IdRequestType);
        console.log('Chip clicked:', chip); 
        // navigate(`/dashboard?request_type=${chip.IdRequestType}&request_name=${chip.RequestType}`);

        if (queryParams.get("cat_req") && queryParams.get("company_id")) {

            let id = queryParams.get("cat_req");
            let buttonName = queryParams.get("cat_nam");
            let company_id = queryParams.get("company_id");

            navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&request_type=${chip.IdRequestType}&request_name=${chip.RequestType}&company_id=${company_id}`);
            fetchRequests(searchQuery, id, chip.IdRequestType, company_id, false); // Filter by user ID and company for "My Ads"

        }else if(queryParams.get("company_id")){

            let request_type_id = queryParams.get("request_type");
            let request_name = queryParams.get("request_name");

            let company_id = queryParams.get("company_id");

            navigate(`/dashboard?request_type=${chip.IdRequestType}&request_name=${chip.RequestType}&company_id=${company_id}`);
            fetchRequests(searchQuery, '', chip.IdRequestType, company_id, false); // Filter by user ID and company for "My Ads"

        } else if (queryParams.get("cat_req")){

            let id = queryParams.get("cat_req");
            let buttonName = queryParams.get("cat_nam");
            
            navigate(`/dashboard?cat_req=${id}&cat_nam=${buttonName}&request_type=${chip.IdRequestType}&request_name=${chip.RequestType}`);
            fetchRequests('',id,chip.IdRequestType);

        } else{
            navigate(`/dashboard?request_type=${chip.IdRequestType}&request_name=${chip.RequestType}`);
        }

    };

    const handleChipDelete = () => {
        setSelectedChip(null);
        console.log('Chip To Delete:', selectedChip);
        // fetchRequests();
        navigate(`/dashboard`);
        window.location.reload();
    };

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + itemsPerPage);
    };

    return (
        <DashboardLayout >
            <DashboardNavbar />

            {/* Loader Component */}
            <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <MDBox py={2}>
                <MDBox px={2} mx={2} mt={1}>
                    <Grid container spacing={3}>

                        {/* <Grid item xs={12} >
                            <MDBox mb={-2}>
                                <Grid

                                    spacing={2}
                                    sx={{
                                        backgroundColor: 'lightgray', // Change to your desired background color
                                        padding: 2,  // Optional: to add some padding inside the grid container
                                        borderRadius: 1,  // Optional: to give rounded corners to the container
                                        '& .MuiGrid-item': { // Target all Grid items inside this container
                                            paddingLeft: '2px', // Negative padding on all items
                                            paddingTop: '2px'
                                        },

                                    }}
                                >
                                    <Grid item xs={12} md={6} lg={4}>
                                        <MDTypography variant="h4" fontWeight="regular" color="text">
                                            
                                            Requests
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                            </MDBox>
                        </Grid> */}

                        <Grid xs={12} pl={3} mt={4}>
                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                                <Stack spacing={2} direction="column" alignItems={''} justifyContent={'flex-start'}>
                                    {/* <h3>Elenco Annunci</h3> */}
                                    {/* <h3>List of Announcements</h3> */}
                                    <h3>Elenco Richieste</h3>
                                    
                                    {/* <p style={{ marginTop: -1, fontSize: '1.2rem', color: '#808080', fontWeight: '500' }}>
                                        Trova tutti bandi di finanza agevolata disponiabili
                                    </p> */}


                                </Stack>
                               { !!(IsAdminPlatform || IsCompanyAdmin) &&
                                <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                    <div>
                                        <Button variant="contained" 
                                         onClick={handleButtonClick} 
                                         sx={{
                                            // backgroundColor: '#183759', 
                                            backgroundColor: 'hsl(210 100% 20%)',
                                            '&:hover': {
                                              backgroundColor: '#1452a5', // slightly lighter/different blue for hover
                                            },
                                            textTransform: '' // optional: disables ALL CAPS if you want
                                          }}

                                         >
                                            {/* <a style={{color: 'white'}}>CREA NUOVO ANNUNCIO</a> */}
                                            {/* <a style={{ color: 'white' }}>CREATE NEW AD</a> */}
                                            <a style={{ color: 'white' }}>Nuova Richiesta</a>
                                        </Button>
                                    </div>
                                </Stack>
                               }
                            </Stack>

                        </Grid>

                        <Grid xs={12} pl={3} mt={4}>
                            <Stack spacing={2} direction="column" alignItems={'center'} justifyContent={'space-between'}>

                                <Stack sx={{ display: 'flex', alignItems: 'center', width: '100%' }} spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                    <Paper
                                        component="form"
                                        // sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', borderRadius: '12px', }}
                                        sx={{
                                            p: '0px 4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%',
                                            borderRadius: '14px',
                                            border: '1px solid #cccccc52', // Light gray border
                                            boxShadow:  'none', // Subtle shadow
                                            background:'#fffffffc'
                                        }}
                                    >
                                        <IconButton sx={{ p: '10px' }} aria-label="menu">
                                            <SearchIcon />
                                        </IconButton>
                                        <InputBase
                                            sx={{ ml: 1,fontSize:'1rem', flex: 1, width: '100%' }}
                                            placeholder="Ricerca"
                                            // placeholder="Research"
                                            inputProps={{ 'aria-label': 'search' }}
                                            value={searchQuery}  // Set the search query value
                                            onChange={handleSearchChange}  // Handle the search input change
                                        />

                                    </Paper>
                                </Stack>

                                {/* Left-aligned Light Grey Badges */}
                                {/* <Box sx={{
                                    display: {
                                        xs: 'none',   // ❌ Hide on extra-small (mobile)
                                        sm: 'none',   // ❌ Hide on small (tablet)
                                        md: 'flex',   // ✅ Show on medium (laptop) and up
                                    }, flexWrap: 'wrap', gap: 1, mt: 1, width: '100%'
                                }}>
                                    {['Badge 1', 'Badge 2', 'Badge 3', 'Badge 4', 'Badge 5'].map((label, index) => (
                                        <Chip
                                            key={index}
                                            label={label}
                                            sx={{
                                                backgroundColor: '#f7f7f7',   // Light grey
                                                color: '#333',
                                                fontWeight: 500,
                                                fontSize: '1.4rem',             // Bigger text
                                                height: '40px',               // Increased height
                                                px: 2,                        // Horizontal padding (theme spacing)
                                                borderRadius: '8px',          // Optional: slightly more rounded
                                            }}
                                        />
                                    ))}
                                </Box> */}

                                {/* Left-aligned Light Grey Badges - Responsive */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 1,
                                        mt: 1,
                                        width: '100%',
                                    }}
                                >
                                    {/* {['Elettronica', 'Fornitura Energia', 'Accuqa e gestione Refiut', 'ICT', 'Meccanica'].map((label, index) => (
                                        <Chip
                                            key={index}
                                            label={label}
                                            variant="outlined" // 👈 outlined style
                                            sx={{
                                                borderColor: '#cccccc59',       // Custom border color
                                                backgroundColor: 'transparent', // just to be safe
                                                color: '#333',
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: '0.85rem',   // Smaller font on mobile
                                                    sm: '0.9rem',
                                                    md: '1rem',
                                                },
                                                height: {
                                                    xs: '25px',
                                                    sm: '36px',
                                                    md: '38px',
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    sm: 2,
                                                },
                                                borderRadius: '8px',
                                            }}
                                        />
                                    ))} */}

                                        {/* multi select and cross icon   */}
                                    {/* {requestTypes.map((label, index) => {
                                        const isSelected = selectedChips.some(c => c.RequestType === label.RequestType);

                                        return (
                                            <Chip
                                                key={index}
                                                label={label.RequestType}
                                                clickable
                                                onClick={() => handleChipClick(label)}
                                                onDelete={isSelected ? () => handleChipDelete(label) : undefined} // 👈 only show "×" if selected
                                                variant="outlined"
                                                sx={{
                                                    borderColor: isSelected ? '#1976d2' : '#cccccc59',
                                                    backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                                    color: isSelected ? '#1976d2' : '#333',
                                                    fontWeight: 500,
                                                    fontSize: {
                                                        xs: '0.85rem',
                                                        sm: '0.9rem',
                                                        md: '1rem',
                                                    },
                                                    height: {
                                                        xs: '25px',
                                                        sm: '36px',
                                                        md: '38px',
                                                    },
                                                    px: {
                                                        xs: 1.5,
                                                        sm: 2,
                                                    },
                                                    borderRadius: '8px',
                                                    '& .MuiChip-deleteIcon': {
                                                        color: '#1976d2',
                                                        fontSize: '18px',
                                                        marginLeft: '4px',
                                                    },
                                                }}
                                            />
                                        );
                                    })} */}

                                        {/* single select and cross icon   */}
                                    {requestTypes.map((label, index) => {
                                        const request_type = queryParams.get("request_type");
                                        
                                        // Use either the state OR the query param to determine selection
                                        const isSelected = selectedChip?.RequestType === label.RequestType || request_type == label.IdRequestType;
                                        
                                        return (
                                            <Chip
                                                key={index}
                                                label={label.RequestType}
                                                clickable
                                                onClick={() => handleChipClick(label)}
                                                onDelete={isSelected ? handleChipDelete : undefined} // ❌ icon only on active chip
                                                variant="outlined"
                                                sx={{
                                                    // borderColor: isSelected ? '#1976d2' : '#cccccc59',
                                                    // backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                                    // color: isSelected ? '#1976d2' : '#333',
                                                    borderColor: isSelected ? '#183759' : '#cccccc59',
                                                    backgroundColor: isSelected ? '#183759' : 'transparent',
                                                    color: isSelected ? '#fff' : '#333',
                                                    fontWeight: 500,
                                                    fontSize: {
                                                        xs: '0.85rem',
                                                        sm: '0.9rem',
                                                        md: '1rem',
                                                    },
                                                    height: {
                                                        xs: '25px',
                                                        sm: '36px',
                                                        md: '38px',
                                                    },
                                                    px: {
                                                        xs: 1.5,
                                                        sm: 2,
                                                    },
                                                    borderRadius: '8px',
                                                    // 👇 Custom hover fix using MUI class targeting
                                                    '&.MuiChip-clickable:hover': {
                                                        backgroundColor: isSelected ? '#204b84' : '#f5f5f5', // no white!
                                                    },
                                                    '& .MuiChip-deleteIcon': {
                                                        color: isSelected ? '#fff' : '#666',
                                                        fontSize: '18px',
                                                        marginLeft: '4px',
                                                        '&:hover': {
                                                            color: isSelected ? '#fff' : '#444',
                                                        },
                                                    },
                                                   
                                                }}
                                            />
                                        );
                                    })}

                                    {/* Filter Button after Badges */}
                                    <Button
                                        // variant="outlined"
                                        // startIcon={<FilterAltOutlinedIcon />}
                                        sx={{
                                            // mt: 1,
                                            display:'none',
                                            borderColor: '#ccc',
                                            color: '#333',
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            px: 2,
                                            py: 0.5,
                                            fontSize: {
                                                xs: '0.85rem',
                                                sm: '0.9rem',
                                                md: '1rem',
                                            },
                                            alignSelf: 'flex-end', // Aligns button to the left
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '22px !important', // ← force override with !important
                                            },
                                        }}
                                    >
                                        <FilterAltOutlinedIcon />
                                        <Typography sx={{ fontSize: '0.95rem', ml: 1, fontWeight: 600, }}>
                                            Filtri avanzati
                                        </Typography>
                                    </Button>
                                </Box>


                            </Stack>
                        </Grid>


                        <Grid container spacing={2} pl={3} mt={4}>
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" sx={{
                                    overflowX: 'auto',
                                    whiteSpace: 'nowrap',
                                    paddingBottom: 1, // optional: for bottom padding
                                    '&::-webkit-scrollbar': {
                                        height: '2px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: '#ccc',
                                        borderRadius: '4px',
                                    },
                                }}>
                                    {/* {requestCategories.slice(0, 2).map((type) => (
                                        <Button
                                            key={type.IdRequestCategory}
                                            sx={{
                                                backgroundColor: activeButton === type.RequestCategory ? '#1A73E8' : '#9d9d9d',
                                                '&:hover': {
                                                    backgroundColor: activeButton === type.RequestCategory ? '#1A73E8' : '#9e9e9e',
                                                },
                                                display: 'inline-block',
                                                minWidth: '120px',        // Ensures buttons have a minimum width
                                                height: '40px',           // Sets a fixed height for buttons
                                                padding: '6px 14px',      // Adds consistent padding for button content
                                                borderRadius: '8px',      // Rounded corners for a softer look
                                                fontWeight: 'bold',       // Makes button text bold
                                                transition: 'all 0.3s ease', // Smooth transition on hover
                                                // textTransform: 'capitalize'
                                            }}
                                            variant="contained"
                                            onClick={() => handleRequestTypeButtonClick(type.RequestCategory, type.IdRequestCategory)}
                                        >
                                            <a style={{ color: 'white' }}>{type.RequestCategory}</a>
                                        </Button>
                                    ))} */}

                                    {/* {requestCategories.slice(0, 2).map((type) => (
                                        <Button
                                            key={type.IdRequestCategory}
                                            onClick={() =>
                                                handleRequestTypeButtonClick(
                                                    type.RequestCategory,
                                                    type.IdRequestCategory
                                                )
                                            }
                                            variant="outlined"
                                            sx={{
                                                backgroundColor:
                                                    activeButton === type.RequestCategory ? "#E3F2FD" : "transparent", // light blue bg if active
                                                borderColor:
                                                    activeButton === type.RequestCategory ? "#1A73E8" : "#cccccc59",
                                                color: activeButton === type.RequestCategory ? "#1A73E8" : "#333",
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: "0.85rem",
                                                    sm: "0.9rem",
                                                    md: "1rem",
                                                },
                                                height: {
                                                    xs: "32px",
                                                    sm: "36px",
                                                    md: "38px",
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    sm: 2,
                                                },
                                                minWidth: "120px",
                                                borderRadius: "8px",
                                                textTransform: "capitalize",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor:
                                                        activeButton === type.RequestCategory ? "#D2E3FC" : "#f0f0f0",
                                                    borderColor: "#1A73E8",
                                                },
                                            }}
                                        >
                                            {type.RequestCategory}
                                        </Button>
                                    ))} */}

                                    {/* {requestCategories.slice(0, 2).map((type) => (
                                        <Button
                                            key={type.IdRequestCategory}
                                            onClick={() =>
                                                handleRequestTypeButtonClick(
                                                    type.RequestCategory,
                                                    type.IdRequestCategory
                                                )
                                            }
                                            variant="outlined"
                                            sx={{
                                                backgroundColor:
                                                    activeButton === type.RequestCategory ? "#36517A" : "transparent", // deep blue when active
                                                borderColor:
                                                    activeButton === type.RequestCategory ? "#183759" : "#cccccc59",   // deep blue border if active
                                                color: activeButton === type.RequestCategory ? "#FFFFFF" : "#183759", // white text on active, navy on default
                                                fontWeight: 550,
                                                fontSize: {
                                                    xs: "0.85rem",
                                                    sm: "0.9rem",
                                                    md: "1rem",
                                                },
                                                height: {
                                                    xs: "32px",
                                                    sm: "36px",
                                                    md: "38px",
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    sm: 2,
                                                },
                                                minWidth: "120px",
                                                borderRadius: "8px",
                                                textTransform: "capitalize",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor:
                                                        activeButton === type.RequestCategory ? "#142d47" : "#f2f6fb", // darker blue on hover if active, pale bg if not
                                                    borderColor: "#183759",
                                                    color: activeButton === type.RequestCategory ? "#FFFFFF" : "#183759",
                                                },
                                            }}
                                        >
                                            {type.RequestCategory}
                                        </Button>
                                    ))} */}

                                    {requestCategories.filter(type => type.show_in_filter === 1).map((type) => (
                                        <Button
                                            key={type.IdRequestCategory}
                                            onClick={() =>
                                                handleRequestTypeButtonClick(
                                                    type.RequestCategory,
                                                    type.IdRequestCategory
                                                )
                                            }
                                            variant="outlined"
                                            sx={{
                                                backgroundColor:
                                                    activeButton === type.RequestCategory ? "#36517A" : "transparent", // deep blue when active
                                                borderColor:
                                                    activeButton === type.RequestCategory ? "#183759" : "#cccccc59",   // deep blue border if active
                                                color: activeButton === type.RequestCategory ? "#FFFFFF" : "#183759", // white text on active, navy on default
                                                fontWeight: 550,
                                                fontSize: {
                                                    xs: "0.85rem",
                                                    sm: "0.9rem",
                                                    md: "1rem",
                                                },
                                                height: {
                                                    xs: "32px",
                                                    sm: "36px",
                                                    md: "38px",
                                                },
                                                px: {
                                                    xs: 1.5,
                                                    sm: 2,
                                                },
                                                minWidth: "120px",
                                                borderRadius: "8px",
                                                textTransform: "capitalize",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor:
                                                        activeButton === type.RequestCategory ? "#142d47" : "#f2f6fb", // darker blue on hover if active, pale bg if not
                                                    borderColor: "#183759",
                                                    color: activeButton === type.RequestCategory ? "#FFFFFF" : "#183759",
                                                },
                                            }}
                                        >
                                            {type.RequestCategory}
                                        </Button>
                                    ))}


                                </Stack>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={4}>

                                <Stack direction="row" spacing={2} alignItems="center" justifyContent={width >= 1024 ? 'flex-start' : width >= 768 ? 'flex-end' : 'flex-start'}>


                                    {/* Toggle switches for "All Ads" and "My Ads" */}
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    color="primary"
                                                    checked={allAds}
                                                    onChange={handleAllAdsChange}
                                                />
                                            }
                                            // label="All ads"
                                            label="Tutte"
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    color="primary"
                                                    checked={myAds}
                                                    onChange={(e) => handleMyAdsChange(e, userCompanyId)} // Passing label to the handler
                                                />
                                            }
                                            label={userCompanyName}
                                        />
                                    </FormGroup>

                                </Stack>

                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <Stack direction="row" spacing={2} alignItems="center" justifyContent={width >= 1024 ? 'flex-end' : 'flex-start'}>
                                    {/* <Typography variant="body2">Filter by</Typography> */}
                                    <Typography variant="body2">Filtra per</Typography>

                                    {/* Dropdown for Typology */}
                                    <FormControl variant="outlined" sx={{ minWidth: 150, ml: 1 }}>
                                        {/* <InputLabel>Typology</InputLabel> */}
                                        <InputLabel>Tipologia</InputLabel>
                                        <Select
                                            // value={selectedRequestType}
                                            value={selectedRequestCategory}
                                            onChange={handleCategoryTypeChange}
                                            label="Typology"
                                            sx={{
                                                height: 40,
                                                minWidth: 110,
                                                '& .MuiSelect-icon': {
                                                    display: 'block !important',
                                                    fontSize: '1.5rem !important',
                                                },
                                            }}
                                            IconComponent={ArrowDropDownIcon}
                                        >
                                            {/* <MenuItem value="">None</MenuItem> */}
                                            <MenuItem value="">Tutte</MenuItem>
                                            {isLoading ? (
                                                <MenuItem disabled>
                                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                                    Loading...
                                                </MenuItem>
                                            ) : requestCategories.length > 0 ? (
                                                requestCategories.filter(type => type.show_in_filter === 1).map((type) => (
                                                    <MenuItem key={type.IdRequestCategory} value={type.IdRequestCategory}>
                                                        {type.RequestCategory}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No request types available</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Stack>
                            </Grid>
                        </Grid>


                        <Grid xs={12} pl={3} mt={4}>

                            {/* <Box sx={{ my: 2 }}> 
                                <Typography
                                    variant="body1"
                                    sx={{
                                        whiteSpace: 'nowrap',         // ensures single line
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',     // handles long text
                                        fontWeight: 600, // Slightly bold
                                    }}
                                >
                                    Monstrando 6 di 369 bandi
                                </Typography>
                            </Box> */}

                            <Grid container spacing={2} >

                                {
                                    currentRequests.map((request, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index} p={1}  >

                                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

                                                {/* Badge Above Header */}
                                                {/* <Box sx={{ px: 2, pt: 2 }}>
                                                    <Chip
                                                        label="Attivo"
                                                        size="small"
                                                        avatar={
                                                            <Box
                                                                sx={{
                                                                    height: 8,
                                                                    width: 8,
                                                                    bgcolor: '#28a745', // green
                                                                    borderRadius: '50%',
                                                                }}
                                                            />
                                                        }
                                                        sx={{
                                                            backgroundColor: '#d4edda',
                                                            color: '#155724',
                                                            fontWeight: 'bold',
                                                            width: 'auto',
                                                            maxWidth: 'fit-content',
                                                            pl: 1, // padding left so the avatar doesn't crowd the text
                                                            // ✅ Targeting the inner avatar class
                                                            '& .MuiChip-avatarSmall': {
                                                                marginLeft: '4px',
                                                                marginRight: '-4px',
                                                                width: '12px',     // or 6px or 4px depending on your dot size
                                                                height: '12px',
                                                            },
                                                        }}
                                                    />
                                                </Box> */}

                                                <CardHeader
                                                    // avatar={<ZoomAvatar src={image042} alt="custom-avatar" />}
                                                    // title={<Typography sx={{cursor: 'pointer'}} variant="h6" onClick={() => handleDetailsClick(request.IdRequest)}>{truncatedDescription(request.Title, 50)}</Typography>}
                                                    title={
                                                        <Box>
                                                            {/* Title */}
                                                            <Typography
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    whiteSpace: 'normal', // Allow multi-line text
                                                                    wordBreak: 'break-word', // Break long words (like emails)
                                                                    hyphens: 'auto', // Adds hyphenation if necessary
                                                                    overflowWrap: 'break-word', // Ensure wrapping for very long words
                                                                    fontFamily: 'Arial, sans-serif', // Font family
                                                                    fontWeight: 800, // Bold font
                                                                }}
                                                                variant="h6"
                                                                onClick={() => handleDetailsClick(request.IdRequest)}
                                                            >
                                                                {truncatedDescription(request.Title, 50)}
                                                            </Typography>

                                                            {/* Location and Icon Below the Title */}
                                                            {/* <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                                                <IconButton sx={{ padding: 0 }} aria-label="location">
                                                                    <LocationOnIcon sx={{ fontSize: 20 }} />
                                                                </IconButton>
                                                                <Typography variant="body2" sx={{ marginLeft: 1 }}>
                                                                    {"Lombardia"} 
                                                                </Typography>
                                                            </Box> */}
                                                        </Box>
                                                    }
                                                    sx={{
                                                        minHeight: {
                                                            // xs: '60px', // For small screens (mobile)
                                                            // sm: '100px', // For tablets
                                                            // md: '185px', // For smaller laptops
                                                            // lg: '182px', // For large laptops and desktops
                                                        },
                                                    }}


                                                />
                                                <CardContent sx={{ flex: 1, }}>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'none',
                                                            color: 'text.secondary',
                                                            fontWeight: 'bold',
                                                            fontSize: { xs: '0.775rem', sm: '0.8rem' }, // Adjust font size based on screen size
                                                        }}
                                                    >
                                                        {/* <b style ={{color:'#000'}} > Category </b> : {request.CategoryName} */}
                                                        <b style={{ color: '#000000' }} > Categoria </b>: {request.CategoryName}
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'none',
                                                            color: 'text.secondary',
                                                            fontWeight: 'bold',
                                                            mt: 1,
                                                            fontSize: { xs: '0.775rem', sm: '0.8rem' }, // Adjust font size based on screen size
                                                        }}
                                                    >
                                                        {/* <b style ={{color:'#000'}} >Type</b> : {request.TypeName} */}
                                                        <b style={{ color: '#000000' }} >Tipologia</b>: {request.TypeName}
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: 'text.secondary',
                                                            mt: 0,
                                                            minHeight: 102,
                                                            whiteSpace: 'pre-line',
                                                            // fontSize: { xs: '0.875rem', sm: '1rem' }, // Adjust font size based on screen size
                                                        }}
                                                    >
                                                        {truncatedDescription(request.Description, 100)}
                                                    </Typography>

                                                    {/* Badge Section */}
                                                    {/* <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: 1,
                                                            mt: 2,
                                                        }}
                                                    >
                                                        <Chip
                                                            label="Elettronica"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: '#e2e3e8',
                                                                color: '#000',
                                                                fontWeight: 'bold',
                                                            }}
                                                        />
                                                        <Chip
                                                            label="Fornitura Energia"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: '#e2e3e8',
                                                                color: '#000',
                                                                fontWeight: 'bold',
                                                            }}
                                                        />
                                                        <Chip
                                                            label="Agroalimentare"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: '#e2e3e8',
                                                                color: '#000',
                                                                fontWeight: 'bold',
                                                            }}
                                                        />
                                                    </Box> */}

                                                </CardContent>


                                                {request.attachment ? (
                                                    <Typography
                                                        sx={{
                                                            ml: 3,
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            fontSize: '0.975rem'
                                                        }}
                                                        variant="body2"
                                                        paragraph
                                                    >
                                                        <strong>Allegato: </strong>
                                                        {request.attachment ? (
                                                            <Link
                                                                onClick={() => window.open(`${fileUploadUrl}/${request.attachment ?? null}`, '_blank')}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    display: 'inline-block',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    maxWidth: '200px',
                                                                    width: '100%',
                                                                    fontSize: '0.975rem',
                                                                    marginLeft: '3px'
                                                                }}
                                                            >
                                                                <AttachFileIcon
                                                                    fontSize={"20"}
                                                                    sx={{
                                                                        color: '#006bd6',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center'
                                                                    }}
                                                                />
                                                            </Link>
                                                        ) : (
                                                            ' No attachment available.'
                                                        )}
                                                    </Typography>
                                                ) : null}

                                                {request.LinkUrl ? (
                                                    <Typography
                                                        sx={{
                                                            ml: 3,
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            fontSize: '0.975rem'
                                                        }}
                                                        variant="body2"
                                                        paragraph
                                                    >
                                                        <strong>Collegamento: </strong>
                                                        {request.LinkUrl ? (
                                                            <Link
                                                                onClick={() => window.open(`${request.LinkUrl ?? null}`, '_blank')}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    display: 'inline-block',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    maxWidth: '200px',
                                                                    width: '100%',
                                                                    fontSize: '0.975rem',
                                                                    marginLeft: '3px'
                                                                }}
                                                            >
                                                                <LinkIcon
                                                                    fontSize={"20"}
                                                                    sx={{
                                                                        color: '#006bd6',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center'
                                                                    }}
                                                                />
                                                            </Link>
                                                        ) : (
                                                            ' No Link available.'
                                                        )}
                                                    </Typography>
                                                ) : null}


                                                {/* <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#007bff',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        fontSize: 14,
                                                        mt: 1,
                                                        ml: 3,
                                                        '&:hover': { textDecoration: 'underline' },
                                                    }}
                                                    onClick={() => handleDetailsClick(request.IdRequest)}
                                                >
                                                    Dettagli
                                                </Typography> */}

                                                <CardActions
                                                    disableSpacing
                                                    sx={{
                                                        padding: 2,
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        // gap:0.5,
                                                        justifyContent: 'space-between',
                                                        marginTop: 'auto',  // Ensures buttons stay at the bottom
                                                    }}
                                                >
                                                    <Stack spacing={2} direction="row" alignItems={'flex-start'} justifyContent={'center'}>
                                                        {/* <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: '#007bff',
                                                                cursor: 'pointer',
                                                                fontWeight: 'bold',
                                                                fontSize: 14,
                                                                mt: 1,
                                                                ml: 3,
                                                                '&:hover': { textDecoration: 'underline' },
                                                            }}
                                                            onClick={() => handleDetailsClick(request.IdRequest)}
                                                        >
                                                            Dettagli
                                                        </Typography> */}
                                                    </Stack>
                                                    <Stack sx={{ width: '100%' }} spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>

                                                        <Button sx={{ background: '#04054C' }} size={"small"} variant="contained">
                                                            <a style={{ color: 'white', cursor: 'default' }}>{request.CategoryName}</a>
                                                        </Button>
                                                        <Button sx={{ background: '#4A60AE' }} size={"small"} variant="contained">
                                                            <a style={{ color: 'white', cursor: 'default' }}>{request.TypeName}</a>
                                                        </Button>
                                                    </Stack>

                                                    {/* {
                                                        requestTypes.slice(0, 2).map((type) => (
                                                            <Button
                                                                sx={{
                                                                    background: '#04054C',
                                                                    marginRight: 1,
                                                                    marginBottom: 1,
                                                                    '&:last-child': { marginRight: 0 },
                                                                    width: {
                                                                        xs: '100%',          // Full width on small screens
                                                                        sm: '48%',           // Half width on small tablet devices
                                                                        md: 'auto',          // Default width on larger screens
                                                                    },
                                                                    '@media (max-width: 960px)': {
                                                                        width: '48%',
                                                                        marginRight: 0.5,        // Tablet screens (sm to md), buttons will take up 48% width
                                                                    },
                                                                    '@media (max-width: 1201px) or (max-width: 1267px)': {
                                                                        width: '48%',
                                                                        marginRight: 0.5,        // Tablet screens (sm to md), buttons will take up 48% width
                                                                    },
                                                                    '@media (max-width: 600px)': { width: '100%' },
                                                                }}
                                                                size={"small"}
                                                                variant="contained"
                                                            >
                                                                <a
                                                                    style={{ color: 'white' }}
                                                                    onClick={() => handleRequestTypeButtonClick(type.RequestType, type.IdRequestType)}
                                                                >
                                                                    {type.RequestType}
                                                                </a>
                                                            </Button>
                                                        ))
                                                    } */}


                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', marginTop: 2 }}>
                                                        {/* View Button */}
                                                        <Button
                                                            variant="contained"
                                                            size="medium"
                                                            sx={{
                                                                textTransform: 'none', // To keep 'View' capitalized as typed
                                                                fontWeight: 'bold',
                                                                color: '#fff',
                                                                borderRadius: 2,
                                                                px: 2.5,
                                                                py: 1,
                                                                flex: 2, // Takes all available space
                                                                backgroundColor: '#183759', 
                                                                // backgroundColor: 'hsl(210 100% 20%)',
                                                                '&:hover': {
                                                                    backgroundColor: '#183759', 
                                                                },
                                                            }}
                                                            onClick={() => handleDetailsClick(request.IdRequest)}
                                                        >
                                                            Vedi Dettagli
                                                        </Button>

                                                        {/* Smaller Heart Icon Button */}
                                                        {/* <IconButton
                                                            size="small"
                                                            sx={{
                                                                // backgroundColor: '#f5f5f5',
                                                                border: '1px solid #ccc',
                                                                width: 36,
                                                                height: 36,
                                                                borderRadius: 1, // Makes it square (4px)
                                                                '&:hover': {
                                                                    backgroundColor: '#e0e0e0',
                                                                },
                                                            }}
                                                        >

                                                            <FavoriteBorderIcon sx={{ fontSize: 18, }} />

                                                        </IconButton> */}
                                                    </Box>

                                                </CardActions>
                                            </Card>


                                        </Grid>
                                    ))
                                }

                            </Grid>
                        </Grid>

                        {/* Pagination */}
                        {/* <Grid item xs={12} mt={3} pl={3}>
                            <Pagination
                                count={Math.ceil(filteredRequests.length / itemsPerPage)}  // Number of pages
                                page={page}  // Current page
                                onChange={handlePageChange}  // Handle page change
                                variant="outlined"
                                color="info"
                                shape="rounded"
                                sx={{ display: 'flex', justifyContent: 'center' }}
                            />
                        </Grid> */}

                        {/* Load More */}
                        {visibleRequests.length < filteredRequests.length && (
                            <Grid item xs={12} mt={3} pl={3} display="flex" justifyContent="center">
                                <Button
                                    variant="outlined"
                                    onClick={handleLoadMore}
                                    sx={{
                                        textTransform: "none",
                                        borderColor: "#183759",
                                        color: "#183759",
                                        fontWeight: 500,
                                        px: 3,
                                        py: 1,
                                        borderRadius: "8px",
                                        "&:hover": {
                                            backgroundColor: "#f2f6fb",
                                            borderColor: "#183759",
                                        },
                                    }}
                                >
                                    {/* Load More */}
                                    Carica altre richieste
                                </Button>
                            </Grid>
                        )}


                    </Grid>
                </MDBox>

            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default RequestList4;

